let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3dm3D")).then(() => parcelRequire('8Q5sE'));